import { Component, OnInit, Inject, LOCALE_ID, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from '../../../service/enrollmentAcceptedStudent.service';
import { CoursesService } from '../../../service/courses.service';
import { GradeSubjectService } from '../../../service/grade-subject.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/service/file.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from 'src/app/service/schedule.service';
import { formatDate, DatePipe } from '@angular/common'
import { AcademicsService } from 'src/app/service/academics.service';
import { AttendanceService } from 'src/app/service/attendance.service';
declare var $: any;


@Component({
  selector: 'app-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.scss']
})
export class ScheduleDetailsComponent implements OnInit {

  editable: boolean = false;
  showLoader: boolean = false;
  showScheduleTableError: boolean = false;
  table: any;

  sectionDay: any = "";
  sectionType: any = "";
  timeFrom: any = "";
  timeTo: any = "";
  scheduleGroupId: any = "";
  scheduleCourseId: any = "";
  primaryScheduleLecturerId: any = "";
  secondaryScheduleLecturerId: any = "";
  scheduleParts: any;
  subjectAssignHours: any = [];
  scheduleId: any;
  yearid: any;
  semesterid: any;
  gradeid: any;
  username: any;
  orgid: any;
  weekDays: any = [];
  editingData: any = false;

  groups: any;
  courses: any;
  teachers: any;
  currentSchedulePartId: any;
  currentSchedulePart: any;
  coursesByGroup: any;
  editCoursesByGroup: any;
  primaryLecturers: any;
  editPrimaryLecturers: any;
  secondaryLecturers: any;
  editSecondaryLecturers: any;
  currentEditSectionCourseId: any = 0;
  currentEditSectionPrimaryLecturerId: any = 0;
  currentEditSectionSecondaryLecturerId: any = 0;

  @ViewChild("scheduleGroupInput") scheduleGroupInput: any;
  @ViewChild("scheduleCourseInput") scheduleCourseInput: any;
  @ViewChild("primaryScheduleLecturerInput") primaryScheduleLecturerInput: any;
  @ViewChild("secondaryScheduleLecturerInput") secondaryScheduleLecturerInput: any;

  editSchedulePartForm = new FormGroup({
    editSectionDay: new FormControl('', [
      Validators.required,
    ]),
    editSectionType: new FormControl('', [
      // Validators.required, 
    ]),
    editTimeFrom: new FormControl('', [
      Validators.required,
    ]),
    editTimeTo: new FormControl('', [
      Validators.required,
    ]),
    editScheduleGroup: new FormControl('', [
      Validators.required,

    ]),
    editScheduleCourse: new FormControl('', [
      Validators.required,
    ]),
    editPrimaryScheduleLecturer: new FormControl('', [
      Validators.required,
    ]),
    editSecondaryScheduleLecturer: new FormControl('', [
      // Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
  });


  constructor(@Inject(LOCALE_ID) private locale: string, private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private coursesService: CoursesService, private gradeSubjectService: GradeSubjectService,
    private enrollmentGroupService: EnrollmentGroupService, private activatedRoute: ActivatedRoute,
    private scheduleService: ScheduleService, private datePipe: DatePipe,
    private academicsService: AcademicsService, private attendanceService: AttendanceService) { }

  ngOnInit(): void {
    this.username = this.globals.currentUserInfo.username;
    this.orgid = this.globals.currentUserInfo.orgid;

    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.scheduleId = params['scheduleId'] || "";
        this.yearid = params['yearid'] || "";
        this.semesterid = params['semesterid'] || "";
        this.gradeid = params['gradeid'] || "";

        if (this.scheduleId != "" && this.yearid != "" && this.semesterid != "" && this.gradeid != "") {
          this.showLoader = true;
          this.getGroups();
          this.getDays();
          // this.getAllCourses();
          this.updateTable();
          // this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_SCHEDULE'));
          this.router.navigate(['/schedule/schedule']);
        }
      });

    // Listen for language change to update table
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();


    });
  }


  updateTable() {
    if (this.table) {
      this.table.destroy();
    } else { $("#datatable").DataTable().destroy(); }
    setTimeout(() => {
      this.table = $("#datatable").DataTable({

        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // scrollX: true,
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: false,
        ordering: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        // buttons: [{
        //   extend: 'excelHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'EXCEL',
        //   exportOptions: {
        //     columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
        //   },
        //   className: 'datatable_custom_buttons',
        // }],
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if (dataTableButtonsDiv != null) {
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }
      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);

  }

  addScheduleSection() {
    this.showScheduleTableError = false;

    if (this.sectionDay.length > 0 && this.sectionType.length > 0 && this.timeFrom.length > 0 && this.timeTo.length > 0) {
      //&& this.secondaryScheduleLecturerId > 0
      if (this.sectionType != 'LECTURE' || (this.sectionType == 'LECTURE' && this.scheduleGroupId > 0 && this.scheduleCourseId > 0 && this.primaryScheduleLecturerId > 0)) {

        let timeFrom = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.timeFrom, "yyyy-MM-dd'T'HH:mm:ss.SSS");
        let timeTo = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.timeTo, "yyyy-MM-dd'T'HH:mm:ss.SSS");

        this.addScheduleDetailSection(this.sectionDay, this.sectionType, timeFrom, timeTo, this.scheduleGroupId, this.scheduleCourseId, this.primaryScheduleLecturerId, this.secondaryScheduleLecturerId);
      } else {
        this.showScheduleTableError = true
      }
    } else {
      this.showScheduleTableError = true
    }
  }

  removeSchedulePart() {
    if (this.currentSchedulePartId) {
      this.deleteScheduleSectionById(this.currentSchedulePartId);
    } else {
      this.toastrService.error(this.translate.instant('THIS_SECTION_NOT_FOUND'));
    }
  }

  updateCurrentSchedulePartId(id: number, edit: any = false) {
    // this.currentRepeaterIndex = index;
    this.currentSchedulePartId = id;
    if (edit) {
      this.currentEditSectionCourseId = 0;
      this.currentEditSectionPrimaryLecturerId = 0;
      this.currentEditSectionSecondaryLecturerId = 0;
      this.getCurrentSchedulePart();
    }
  }


  getAllCourses() {
    // this.showLoader = true;
    this.coursesService.getAllCourses()
      .subscribe(
        data => {
          this.courses = data;
          this.getAllTeachers();
          // this.updateTable();
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.showLoader = false

        },
        // () => this.showLoader = false
      );
  }

  getAllTeachers() {
    // this.showLoader = true;
    this.academicsService.getTeachers()
      .subscribe(
        data => {
          this.teachers = data;
          this.getScheduleDetailsByHeaderId();
          // this.updateTable();
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.showLoader = false

        },
        // () => this.showLoader = false
      );
  }


  deleteScheduleSectionById(id: number) {
    // this.showLoader = true;
    // console.log('delete schedule section');
    this.deleteScheduleSectionByIdService(id);
  }

  // getGroups() {
  //   this.enrollmentGroupService.getAllGroups()
  //     .subscribe(
  //       data => {
  //         this.groups = data;
  //         this.getAllCourses();
  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }

  getGroups() {
    this.attendanceService.getBatchGroups(this.orgid, this.gradeid)
      .subscribe(
        data => {
          this.groups = data;
          this.getAllCourses();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  saveScheduleParts() {
    console.log('Save schedule parts');
  }

  previewSchedule() {
    console.log('Preview Schedule');
  }

  getScheduleDetailsByHeaderId() {
    this.showLoader = true;
    this.scheduleService.getScheduleDetailByHeaderId(this.scheduleId)
      .subscribe(
        data => {
          data = data.map((element: any) => {
            let course = this.courses.filter((i: any) => i.id == element.subjectid)[0];
            let group = this.groups.filter((i: any) => i.id == element.groupid)[0];
            let primarylecture = this.teachers.filter((i: any) => i.id == element.primaryTeacherid)[0];
            let secondarylecture = this.teachers.filter((i: any) => i.id == element.secondaryTeacherid)[0];
            return { ...element, group, course, primarylecture, secondarylecture };
          });

          this.scheduleParts = data;

          this.getScheduleDetailSummary();
          this.showLoader = false;
          this.updateTable();
        },
        error => {
          this.showLoader = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getScheduleDetailSummary() {
    this.scheduleService.getScheduleDetailSummary(this.orgid, this.yearid, this.semesterid, this.gradeid, this.scheduleId)
      .subscribe(
        data => {
          this.subjectAssignHours = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_SUMMARY_DATA_BE'));
        }
      );
  }

  getCurrentSchedulePart() {
    this.editSchedulePartForm.reset();
    this.editingData = true;
    this.scheduleService.getScheduleDetailSlotById(this.currentSchedulePartId)
      .subscribe(
        data => {
          this.currentSchedulePart = data;
          this.editSchedulePartForm.controls.editSectionDay.setValue(data.schDay);
          this.editSchedulePartForm.controls.editSectionType.setValue(data.schDayType);
          // this.editSchedulePartForm.controls.editTimeFrom.setValue(data.schTimeFrom);
          // this.editSchedulePartForm.controls.editTimeTo.setValue(data.schTimeTo);
          this.editSchedulePartForm.controls.editScheduleGroup.setValue(data.groupid);
          this.getCoursesByGroup(true, data.groupid);
          this.currentEditSectionCourseId = data.subjectid;
          this.currentEditSectionPrimaryLecturerId = data.primaryTeacherid;
          this.currentEditSectionSecondaryLecturerId = data.secondaryTeacherid;

          this.editSchedulePartForm.controls.editTimeFrom.setValue(formatDate(new Date(data.schTimeFrom), 'HH:mm', this.locale));
          this.editSchedulePartForm.controls.editTimeTo.setValue(formatDate(new Date(data.schTimeTo), 'HH:mm', this.locale));

          // this.editSchedulePartForm.controls.scheduleCourse.setValue(data.subjectid);
          // this.editSchedulePartForm.controls.primaryScheduleLecturer.setValue(data.primaryTeacherid);
          // this.editSchedulePartForm.controls.secondaryScheduleLecturer.setValue(data.secondaryTeacherid);
          this.editSchedulePartForm.controls.active.setValue(data.active);
          this.onChangeSectionType();
          this.editingData = false;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.editingData = false;
        }
      );
  }

  deleteScheduleSectionByIdService(sectionId: number) {
    this.scheduleService.deleteScheduleSectionById(this.username, sectionId)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
            this.getScheduleDetailsByHeaderId();
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('FAIL_TO_Delete'));
        }
      );
  }


  addScheduleDetailSection(sectionDay: string, sectionType: string, timeFrom: any, timeTo: any, groupId: number, courseId: number, primaryScheduleLecturerId: number, secondaryScheduleLecturerId: number) {

    this.scheduleService.addScheduleDetailSection(this.username, this.orgid, this.yearid, this.semesterid, this.gradeid, this.scheduleId, sectionDay, sectionType, timeFrom, timeTo, groupId, courseId, primaryScheduleLecturerId, secondaryScheduleLecturerId)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.sectionDay = "";
            this.sectionType = "";
            this.timeFrom = "";
            this.timeTo = "";
            this.scheduleGroupId = "";
            this.scheduleCourseId = "";
            this.primaryScheduleLecturerId = "";
            this.secondaryScheduleLecturerId = "";
            this.scheduleGroupInput.nativeElement.value = "";
            this.scheduleCourseInput.nativeElement.value = "";
            this.primaryScheduleLecturerInput.nativeElement.value = "";
            this.secondaryScheduleLecturerInput.nativeElement.value = "";
            // this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.getScheduleDetailsByHeaderId();
          } else if (data.sts == "CAUTION") {
            if (this.globals.lang == "ar") {
              this.toastrService.warning(data.arMsg);
            } else {
              this.toastrService.warning(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }

          }
        },
        error => {
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

  getCoursesByGroup(editing: boolean = false, editGroupId: any = 0) {
    // console.log("reda");
    // console.log(this.scheduleGroupId);
    this.editCoursesByGroup = [];
    this.coursesByGroup = [];
    this.editPrimaryLecturers = [];
    this.primaryLecturers = [];
    this.secondaryLecturers = [];
    this.editSecondaryLecturers = [];

    this.scheduleCourseId = "";
    this.scheduleCourseInput.nativeElement.value = "";
    this.primaryScheduleLecturerId = "";
    this.primaryScheduleLecturerInput.nativeElement.value = "";
    this.secondaryScheduleLecturerId = "";
    this.secondaryScheduleLecturerInput.nativeElement.value = "";

    let groupId = this.scheduleGroupId;
    if (editing) {
      if (editGroupId > 0) {
        groupId = editGroupId;
      } else {
        this.currentEditSectionCourseId = 0;
        this.currentEditSectionPrimaryLecturerId = 0;
        this.currentEditSectionSecondaryLecturerId = 0;
        groupId = this.editSchedulePartForm.controls.editScheduleGroup.value;
      }
    }

    if (groupId > 0) {    //static-value 20211
      this.coursesService.getSubjectsByGroupSubjectId(this.orgid, this.yearid, this.semesterid, groupId)
        .subscribe(
          data => {
            if (data && data.length) {
              if (editing) {
                this.editCoursesByGroup = data;
              } else {
                this.coursesByGroup = data;
              }

              if (data[0] != null) {
                if (editing) {
                  if (this.currentEditSectionCourseId > 0) {
                    setTimeout(() => {
                      this.editSchedulePartForm.controls.editScheduleCourse.setValue(this.currentEditSectionCourseId);
                    }, 500);
                  } else {
                    setTimeout(() => {
                      this.editSchedulePartForm.controls.editScheduleCourse.setValue(data[0].id);
                    }, 500);
                  }
                } else {
                  this.scheduleCourseId = data[0].id;
                }
                this.getPrimaryLecturerBySubjectId(data[0].id, editing);
              }
              // this.updateTable();
            }
          },
          error => {

            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
            // this.showLoader = false

          },
          // () => this.showLoader = false
        );
    }

  }

  getPrimaryLecturerBySubjectId(courseId: any, editing: boolean = false) {
    this.academicsService.getTeacherCourseBycourseAndType(this.orgid, courseId, "PRIMARY")
      .subscribe(
        data => {
          if (data && data.length) {
            // console.log(data);
            if (editing) {
              this.editPrimaryLecturers = data;
            } else {
              this.primaryLecturers = data;
            }

            if (data[0] != null) {
              if (editing) {
                if (this.currentEditSectionPrimaryLecturerId > 0) {
                  setTimeout(() => {
                    this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.setValue(this.currentEditSectionPrimaryLecturerId);
                  }, 500);

                } else {
                  setTimeout(() => {
                    this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.setValue(data[0].id);
                  }, 500);
                }

              } else {
                this.primaryScheduleLecturerId = data[0].id;
              }
              this.getSecondaryLecturerBySubjectId(courseId, editing);
            }
            // this.updateTable();
          }

        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.showLoader = false

        },
        // () => this.showLoader = false
      );
  }

  getSecondaryLecturerBySubjectId(courseId: any, editing: boolean = false) {
    this.academicsService.getTeacherCourseBycourseAndType(this.orgid, courseId, "SECONDARY")
      .subscribe(
        data => {
          if (data && data.length) {
            // console.log(data);
            if (data[0] != null) {
              if (editing) {
                this.editSecondaryLecturers = data;
                if (this.currentEditSectionPrimaryLecturerId > 0) {
                  setTimeout(() => {
                    this.editSchedulePartForm.controls.editSecondaryScheduleLecturer.setValue(this.currentEditSectionSecondaryLecturerId);
                  }, 500);
                } else {
                  setTimeout(() => {
                    this.editSchedulePartForm.controls.editSecondaryScheduleLecturer.setValue(data[0].id);
                  }, 500);
                }

              } else {
                this.secondaryScheduleLecturerId = data[0].id;
                this.secondaryLecturers = data;
              }
            }
            // this.updateTable();
          }

        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.showLoader = false

        },
        // () => this.showLoader = false
      );
  }

  getDays() {
    this.scheduleService.getDays(this.orgid)
      .subscribe(
        data => {
          this.weekDays = data;
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));

        },
      );
  }

  onChangeSectionType() {
    // console.log(this.editSchedulePartForm.controls.editScheduleGroup.value);
    if (this.editSchedulePartForm.controls.editSectionType.value === 'BREAK') {
      this.editSchedulePartForm.controls.editScheduleGroup.setValidators(null);
      this.editSchedulePartForm.controls.editScheduleGroup.updateValueAndValidity();
      this.editSchedulePartForm.controls.editScheduleCourse.setValidators(null);
      this.editSchedulePartForm.controls.editScheduleCourse.updateValueAndValidity();
      this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.setValidators(null);
      this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.updateValueAndValidity();

    } else {
      this.editSchedulePartForm.controls.editScheduleGroup.setValidators([Validators.required]);
      this.editSchedulePartForm.controls.editScheduleGroup.updateValueAndValidity();
      this.editSchedulePartForm.controls.editScheduleCourse.setValidators([Validators.required]);
      this.editSchedulePartForm.controls.editScheduleCourse.updateValueAndValidity();
      this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.setValidators([Validators.required]);
      this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.updateValueAndValidity();

    }
  }

  editSchedulePartFormSubmit() {
    if (this.editSchedulePartForm.valid) {
      if (this.currentSchedulePart) {
        // console.log(this.editSchedulePartForm.value);
        let timeFrom = this.editSchedulePartForm.controls.editTimeFrom.value;
        let timeTo = this.editSchedulePartForm.controls.editTimeTo.value;

        this.currentSchedulePart.schDay = this.editSchedulePartForm.controls.editSectionDay.value;
        this.currentSchedulePart.schDayType = this.editSchedulePartForm.controls.editSectionType.value;
        this.currentSchedulePart.schTimeFrom = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + timeFrom, "yyyy-MM-dd'T'HH:mm:ss.SSS");
        this.currentSchedulePart.schTimeTo = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + timeTo, "yyyy-MM-dd'T'HH:mm:ss.SSS");
        this.currentSchedulePart.groupid = this.editSchedulePartForm.controls.editScheduleGroup.value;
        this.currentSchedulePart.subjectid = this.editSchedulePartForm.controls.editScheduleCourse.value;
        this.currentSchedulePart.primaryTeacherid = this.editSchedulePartForm.controls.editPrimaryScheduleLecturer.value;
        this.currentSchedulePart.secondaryTeacherid = this.editSchedulePartForm.controls.editSecondaryScheduleLecturer.value;
        this.currentSchedulePart.active = this.editSchedulePartForm.controls.active.value;
        this.updateScheduleSlot();
      } else {
        this.toastrService.error(this.translate.instant('SCHEDULE_SECTION_NOT_FOUND'));

      }
    } else {
      this.editSchedulePartForm.markAllAsTouched();
      this.editSchedulePartForm.markAsDirty();
    }
  }

  updateScheduleSlot() {
    this.editingData = true;
    this.scheduleService.updateScheduleDetailSlot(this.username, this.currentSchedulePart)
      .subscribe(
        data => {
          this.editingData = false;
          if (data.sts == "SUCCESS") {
            $("#close-schedule-slot-edit").trigger("click");
            // this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.getScheduleDetailsByHeaderId();
          } else if (data.sts == "CAUTION") {
            if (this.globals.lang == "ar") {
              this.toastrService.warning(data.arMsg);
            } else {
              this.toastrService.warning(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }

          }
        },
        error => {
          this.editingData = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
        }
      );
  }

}
